export interface ProductVariation {
  name: string
  price: string
  sizes: string[]
  colors: { name: string; hex: string }[]
  x: number
  y: number
}

export interface LookbookItem {
  id: string
  title: string
  model: string
  image: string
  gallery: string[]
  description: string
  narrative: string
  products: ProductVariation[]
}

export const lookbookCollections: LookbookItem[] = [
  {
    id: 'casual-wear',
    title: 'Casual Wear Looks',
    model: 'Kofi A.',
    image:
      'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'Effortless everyday style with a heritage twist.',
    narrative: 'Comfort meets culture in our casual essentials.',
    products: [
      {
        name: 'Linen Heritage Shirt',
        price: '$145',
        sizes: ['S', 'M', 'L', 'XL'],
        colors: [{ name: 'Sand', hex: '#C2B280' }],
        x: 50,
        y: 40,
      },
    ],
  },
  {
    id: 'african-casual',
    title: 'African Casual Looks',
    model: 'Amara D.',
    image:
      'https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png',
      'https://cdn.magicpatterns.com/uploads/bxTL7vVABPe8YuDE1LiVeu/image.png',
    ],
    description: 'Traditional textiles reimagined for modern leisure.',
    narrative: 'Vibrant Ankara prints in relaxed, contemporary silhouettes.',
    products: [
      {
        name: 'Ankara Wrap Top',
        price: '$120',
        sizes: ['S', 'M', 'L'],
        colors: [{ name: 'Vibrant Blue', hex: '#0000FF' }],
        x: 45,
        y: 35,
      },
    ],
  },
  {
    id: 'prom-looks',
    title: 'Prom Looks',
    model: 'Imani O.',
    image:
      'https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=1200',
      'https://cdn.magicpatterns.com/uploads/7mhXL4wLM3RtBppQHvnPxN/image.png',
    ],
    description: 'High-fashion evening wear for unforgettable moments.',
    narrative: 'Silk-blend Kente and hand-finished lace for the spotlight.',
    products: [
      {
        name: 'Silk Kente Gown',
        price: '$1,200',
        sizes: ['XS', 'S', 'M', 'L'],
        colors: [{ name: 'Crimson', hex: '#DC143C' }],
        x: 40,
        y: 45,
      },
    ],
  },
  {
    id: 'wedding-looks',
    title: 'Wedding Looks',
    model: 'Zara K.',
    image:
      'https://images.unsplash.com/photo-1594473030772-ddc15393285c?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1594473030772-ddc15393285c?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1546167108-8395d2df9ac1?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'Bespoke bridal heritage for your special day.',
    narrative: 'Intricate embroidery and luxury silks for the modern bride.',
    products: [
      {
        name: 'Bespoke Bridal Gown',
        price: '$2,500',
        sizes: ['Custom'],
        colors: [{ name: 'Ivory', hex: '#FFFFF0' }],
        x: 50,
        y: 50,
      },
    ],
  },
  {
    id: 'business-casual',
    title: 'Business Casual Looks',
    model: 'Kwame B.',
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'Professionalism meets cultural identity.',
    narrative: 'Tailored blazers and shirts with subtle heritage details.',
    products: [
      {
        name: 'Kente Detail Blazer',
        price: '$350',
        sizes: ['M', 'L', 'XL'],
        colors: [{ name: 'Navy', hex: '#000080' }],
        x: 55,
        y: 30,
      },
    ],
  },
  {
    id: 'professional-looks',
    title: 'Professional Looks',
    model: 'Nala M.',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1200',
    gallery: [
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1200',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=1200',
    ],
    description: 'Command the room with heritage-inspired authority.',
    narrative:
      'Sharp tailoring and sophisticated silhouettes for the boardroom.',
    products: [
      {
        name: 'Heritage Power Suit',
        price: '$580',
        sizes: ['S', 'M', 'L'],
        colors: [{ name: 'Charcoal', hex: '#36454F' }],
        x: 45,
        y: 40,
      },
    ],
  },
]
